import { CONFIG } from "~/config";

export const COLOR = "#ff3c00";
export const HOVER_COLOR = "#6b7580";
export const POINT_RADIUS = 7;
export const POINT = {
	color: COLOR,
	opacity: 1,
	outlineWidth: 1,
	outlineColor: "#ffffff",
};
export const POINT_HOVER = {
	...POINT,
	color: HOVER_COLOR,
};
export const POINT_START = {
	...POINT,
	color: "#ffffff",
	outlineColor: COLOR,
	outlineWidth: 2,
};
export const POINT_START_HOVER = {
	...POINT_START,
	outlineColor: HOVER_COLOR,
};
export const LINE = {
	color: COLOR,
	width: 4,
	opacity: 1,
	style: JAK.Vector.STYLE_SOLID,
	outlineWidth: 0,
	outlineColor: "#ffffff",
};
export const LINE_DASH = {
	...LINE,
	style: JAK.Vector.STYLE_DASH,
};
export const LINE_HOVER = {
	...LINE,
	color: HOVER_COLOR,
};

export default class Geom {
	_layer: any;

	_scene: any;

	_nodes: Array<HTMLElement>;

	_geom: any;

	_coords: any;

	_bindScope: any;

	constructor(layer, scene) {
		this._layer = layer;
		this._scene = scene;
		this._nodes = [];
		this._geom = null;
		this._coords = null;
		this._bindScope = this;
	}

	destroy() {
		this.remove();
	}

	/**
	 * Ziskani geometrie.
	 */
	get geom() {
		return this._geom;
	}

	/**
	 * Ziskani souradnic geometrie.
	 */
	getCoords() {
		return this._coords;
	}

	/**
	 * Ziskani nodu s geometrii
	 */
	getNodes() {
		return this._nodes;
	}

	/**
	 * Odstraneni geometrie.
	 */
	remove() {
		if (this._geom) {
			this.unbind();
			this._layer.removeGeometry(this._geom);
			this._geom = null;
			this._nodes = [];
		}
	}

	/**
	 * Nastaveni stylu geometrie.
	 */
	setStyle(style) {
		if (style && this._geom) {
			this._geom.setOptions(style);
		}
	}

	/**
	 * Rebind elementu - pri map redraw se znovu vykresli geometrie, takze stary eventy jsou k nicemu, je nutno je znovu navesit.
	 */
	bindTo(bindScope: any = this) {
		this._bindScope = bindScope;

		if (!this._geom) {
			return;
		}

		this._geom.getNodes(nodes => {
			this._nodes = nodes;
			this._nodes.forEach(el => {
				if (!CONFIG.inFrame) {
					if (!Mapy.Util.isMobile()) {
						el.addEventListener("pointerenter", this._bindScope);
						el.addEventListener("pointerleave", this._bindScope);
					}

					el.addEventListener("pointerup", this._bindScope);
				}

				el.addEventListener("pointerdown", this._bindScope);
			});
		});
	}

	/**
	 * Unbind vsech udalosti.
	 */
	unbind() {
		this._nodes.forEach(el => {
			if (!CONFIG.inFrame) {
				if (!Mapy.Util.isMobile()) {
					el.removeEventListener("pointerenter", this._bindScope);
					el.removeEventListener("pointerleave", this._bindScope);
				}

				el.removeEventListener("pointerup", this._bindScope);
			}

			el.removeEventListener("pointerdown", this._bindScope);
		});
	}

	/**
	 * Test, jestli dany element spada pod geometrii.
	 */
	elTest(testEl) {
		let test = false;

		this._nodes.every(el => {
			if (testEl === el || (typeof el.contains === "function" && el.contains(testEl))) {
				test = true;

				return false;
			}

			return true;
		});

		return test;
	}

	/**
	 * Vytvoreni geometrii - pomocna fce.
	 */
	_create(coords, geom) {
		this.remove();

		this._coords = coords;
		this._geom = geom;
		this._layer.addGeometry(this._geom);

		return geom;
	}
}
